@let bankAccount = bankAccount$ | async;

<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Carteira'"
    [titleIcon]="'pi pi-wallet'"
    [subtitle]="'Aqui você pode consultar o saldo de suas vendas e realizar saques.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      { label: 'Carteira', icon: 'pi pi-wallet' },
    ]">
    <div class="wallet-header--buttons">
      @if (wallet$ | async; as wallet) {
        <span class="wallet-badge rounded-pill">
          Entradas: {{ (wallet.sales_total | currency: "BRL")! }} | Saldo disponível:
          {{ (withdrawableBalance(wallet) | currency: "BRL")! }}
        </span>
        <app-button
          styleType="secondary"
          (btnClick)="handleRequestWithdrawClick(wallet, bankAccount)">
          Sacar
        </app-button>
      }
    </div>
  </app-page-header>
  <ng-container>
    <div class="container-fluid p-3">
      <div class="row wallet-body pb-5">
        <div class="col-12 col-lg-5 d-flex flex-column gap-4 mb-4">
          @if (wallet$ | async; as wallet) {
            <app-data-card
              title="Saldo a liberar:"
              [data]="(wallet.balance_not_released | currency: 'BRL')!"
              icon="currency"
              collapsibleInfo="Valores das vendas que serão liberados após a compensação, ocorrida em até 3 dias após o término do evento." />
            <app-data-card
              title="Disponível para saque:"
              [data]="(withdrawableBalance(wallet) | currency: 'BRL')!"
              icon="currency"
              collapsibleInfo="Saldo já compensado, descontadas as solicitações de saque que ainda estão em análise." />
          } @else {
            <p-skeleton height="120px" />
            <p-skeleton height="120px" />
          }

          <app-card-bank-account
            [account_info]="bankAccount"
            [deleting]="deletingBankAccount"
            (editBankAccountClick)="handleEditBankAccountClick($event)"
            (deleteBankAccountClick)="handleDeleteBankAccountClick()"
            (viewPendingChangesClick)="handleViewPendingChangesClick()" />
        </div>

        <div class="col-12 col-lg-7">
          <div class="card mb-4 p-3">
            <app-section-header title="Extrato da Conta" />
            <app-statement-filters (filterChange)="handleAccountStatementFilterChange($event)" />
            <app-account-statement-table
              [transactions]="transactions$ | async"
              (pageChange)="handleAccountStatementChange($event)" />
          </div>

          <!-- TODO: Reativar tab de últimos saques quando necessário
          <div class="card mb-4">
            <h5 class="p-3 mb-0">Últimos Saques</h5>
            <app-last-withdrawals-table
              [withdrawals]="withdrawals$ | async"
              (pageChange)="handleLastWithdrawalsChange($event)" />
          </div>
          -->
        </div>
      </div>
    </div>
  </ng-container>
</app-layout>
